import {AfterViewInit, Component, ElementRef, Input, NgZone, OnInit, ViewChild} from '@angular/core';
import {Router} from "@angular/router";
import {AppConstants} from "../../constants/app-constants";
import { SocialAuthService, SocialUser } from '@abacritt/angularx-social-login';
import { Observer } from 'rxjs';
import { UserService } from 'src/app/services/user/user.service';
import { StorageService } from 'src/app/services/storage/storage.service';

/**
 * LoginPageComponent represents the login page of the application
 */
@Component({
    selector: 'app-login',
    templateUrl: './login-page.component.html',
    styleUrls: ['./login-page.component.scss']
})
export class LoginPageComponent implements OnInit, AfterViewInit {
  /** The width of the google sign in button */
  private _viewportObserver: ResizeObserver;
  public buttonWidth: number = 300;
  public buttonSize: "small" | "medium" | "large" = "medium";

  /** The wrapper element */
  @ViewChild("wrapper") wrapper: ElementRef | null = null;

  /**
   * Default constructor to initalize services 
   * 
   * @param authService
   * @param router 
   */
  constructor(
    private _userService: UserService,
    private _zone: NgZone,
    private _router: Router,
  ) {
    // Create a new viewport observer to detect viewport changes and update the sign in button accordingly
    this._viewportObserver = new ResizeObserver(
      (entries: ResizeObserverEntry[]): void => {
        this._zone.run(() => {
          this.buttonWidth = min(max(entries[0].contentRect.width, 200), 400);
          this.buttonSize = this.buttonWidth >= 375 ? "large" : "small";
        });
      });
  }

  /**
   * When the component is first initalized, check if they're authenticated and if their input is valid
   */
  ngOnInit(): void {
    // Check for immediate changes
    if (this._userService.authenticated) this._router.navigate(["/"]);

    // Subscribe to session storage changes to navigate home
    this._userService.authenticated$.subscribe(
      (authenticated: boolean): void => {
        if (authenticated) this._router.navigate(["/"])
      });

  }

  /**
   * When the component loads view children start listening to the viewport observer
   */
  ngAfterViewInit(): void {
    if (this.wrapper != null) this._viewportObserver.observe(this.wrapper.nativeElement);
  }
}

/** Utility Functions */

const max = (x: number, y: number): number => {
  return x > y ? x : y;
}

const min = (x: number, y: number): number => {
  return x < y ? x : y;
}
